module.exports = __webpack_public_path__ + "img/logo.8b71ba92.png";